import { z } from "zod";
import { subCategoryResultSchema } from "@/schema/improvement-proposal/SubCategoryResult";

export const mainCategoryResultSchema = z.object({
  id: z.number(),
  content: z.string(),
  sub_category_results: z.array(subCategoryResultSchema),
});

export type MainCategoryResult = z.infer<typeof mainCategoryResultSchema>;